import { z } from 'zod';
import { MIN_PASSWORD_LENGTH } from './account.js';
/* ═══════════════════════════════════════════════════════════════════════
 * STUDENT PLATFORM — invitations and what a signed-in student sees.
 *
 * There is no public sign-up and no mailer, so an account starts life with
 * no password at all: Diana creates it, hands over a one-time link however
 * she already talks to that person, and the student chooses the password
 * themselves. She never learns it.
 * ═══════════════════════════════════════════════════════════════════════ */
/** How long a link is worth sending. Long enough to survive a weekend. */
export const INVITE_TTL_DAYS = 14;
/**
 * Creating the login for a client card. The name and e-mail come from the
 * card, but the e-mail is the sign-in address and has to be real — the one
 * on the card is a free-text note and often empty.
 */
export const createStudentAccountSchema = z.object({
    email: z.string().trim().toLowerCase().pipe(z.email().max(255)),
    name: z.string().trim().min(1, 'Podaj imię').max(120),
});
/** Setting a password from an invite link. */
export const redeemInviteSchema = z.object({
    password: z.string().min(MIN_PASSWORD_LENGTH).max(200),
});
/**
 * What the invite page may show before anyone has proved anything. Enough to
 * reassure the right person they are in the right place, and nothing that
 * would reward someone guessing tokens.
 */
export const inviteInfoSchema = z.object({
    name: z.string(),
    email: z.string(),
});
